module.exports = __webpack_public_path__ + "img/bogen.766c9c03.png";